/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import ContentLoader from 'react-content-loader';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Done from '@material-ui/icons/Done';
import Edit from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Updated from '@material-ui/icons/EditOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Reprocess from '@material-ui/icons/SettingsBackupRestore';
import LinearProgress from '@material-ui/core/LinearProgress';
import Refresh from '@material-ui/icons/Refresh';
import AddIco from '@material-ui/icons/AddCircle';
import Publish from '@material-ui/icons/CloudUpload';
import UnPublish from '@material-ui/icons/CloudDownload';
import Map from '@material-ui/icons/PinDropOutlined';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import Checkbox from '@material-ui/core/Checkbox';
import { Zoom, Tooltip } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
import Snackbar from 'components/UI/Snackbar/Snackbar';
// global variables
import { adStatus } from 'config';
// our components
import { AD, USER } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import ModalConfirmation from 'components/common/ModalConfirmation/ModalConfirmation';
import { LoadingAnimation } from 'components/common/Loading';
import Paginator from 'components/common/Paginator';
import { TableLoader } from 'components/common/TableLoader';
import Order from 'components/Ad/Order';
import Filter from 'components/Ad/Filter';
import WithPermission from 'components/User/WithPermission';
import Badge from 'components/UI/Badge/Badge';
import matchedRules, { isFromList } from 'helpers/matchedRulesHelper';
import dateFormat from 'helpers/dateHelper';
import ImageMosaic from 'components/common/ImageMosaic/ImageMosaic';

const hasReviewCategoryRule = ad =>
  ad &&
  Array.isArray(ad.matchedRules) &&
  ad.matchedRules.some(rule => Object.keys(rule)[0] === 'review_category');

const getReviewCategorySuggestion = ad => {
  if (!hasReviewCategoryRule(ad)) {
    return '';
  }
  const reviewCategoryRule = ad.matchedRules.find(
    rule => Object.keys(rule)[0] === 'review_category',
  );
  const payload = reviewCategoryRule.review_category;

  if (payload === null || payload === undefined) {
    return '';
  }
  if (typeof payload === 'string' || typeof payload === 'number') {
    return `${payload}`;
  }
  if (typeof payload === 'object') {
    return `${payload.category_id ||
      payload.subcategoryId ||
      payload.subcategory_id ||
      payload.subcategory ||
      payload.id ||
      ''}`;
  }
  return '';
};

/**
 * @description - AdList component
 * @augments React.Component
 */
class AdList extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
      modalIsOpen: false,
      adTitle: '',
      showCollapseFilters: true,
    };
  }

  /**
   * @description
   * Select all items.
   *
   * @param {Array} edges - All ads from api.
   * @returns {undefined} No return.
   */
  handleSelectAll = edges => {
    const { selectedItems } = this.state;
    // if all are selected
    if (selectedItems.length === edges.length) {
      this.setState({ selectedItems: [] });
    } else {
      this.setState({ selectedItems: edges.map(item => item.node.id) });
    }
  };

  /**
   * @description
   * Select an item.
   *
   * @param {number} id - Id of selected item.
   * @returns {undefined} No return.
   */
  handleSelectItem = id => {
    const { selectedItems } = this.state;
    // if item is selected
    if (selectedItems.indexOf(id) !== -1) {
      this.setState({
        selectedItems: selectedItems.filter(item => item !== id),
      });
    } else {
      this.setState({ selectedItems: [...selectedItems, id] });
    }
  };

  /**
   * @description
   * Handle delete, publish, unpublish or review action.
   *
   * @param {string} action - Specific action.
   * @param {Array} selectedItems - Items ids.
   * @param {string} categoryId - Suggested category from matched rules.
   */
  handleAction = (action, selectedItems, categoryId) => {
    const {
      adReview,
      adUnReview,
      adPublish,
      adUnPublish,
      adReprocess,
      adApplyRuleAndPublish,
    } = this.props;
    if (action === 'review') {
      adReview(selectedItems);
    } else if (action === 'unreview') {
      adUnReview(selectedItems);
    } else if (action === 'publish') {
      adPublish(selectedItems);
    } else if (action === 'unpublish') {
      adUnPublish(selectedItems);
    } else if (action === 'reprocess') {
      adReprocess(selectedItems);
    } else if (action === 'applyRuleAndPublish') {
      adApplyRuleAndPublish(selectedItems, categoryId);
    }
    this.setState({ selectedItems: [] });
  };

  /**
   * @description
   * Redirect to ad/create route.
   */
  handleCreate = () => {
    const history = this.context;
    history.push(AD.CREATE);
  };

  /**
   * @description
   * Redirect to ad/update route.
   *
   * @param {number} id - Id of the ad to update.
   */
  handleUpdate = id => {
    const history = this.context;
    history.push(formatRoute(AD.UPDATE, { id }));
  };

  /**
   * @description
   * Redirect to user/read route.
   *
   * @param {number} id - Id of the user to read.
   */
  handleReadUser = id => {
    const history = this.context;
    history.push(formatRoute(USER.DETAILS, { id }));
  };

  /**
   * @description
   * Callback to close destroying modal if user close it manually.
   */
  handleCloseModal = () => {
    this.setState({ modalIsOpen: false, adTitle: '' });
  };

  /**
   * @description
   * Handle show collapsed or full filters.
   */
  handleShowFilters = () => {
    const { showCollapseFilters } = this.state;
    this.setState({ showCollapseFilters: !showCollapseFilters });
  };

  /**
   * @description
   * Call refresh callback.
   */
  handleRefresh = () => {
    const { refresh } = this.props;
    refresh();
  };

  /**
   * @description
   * Render Status cell.
   *
   * @param {Object} node - An ad.
   * @returns {*} Status cell.
   */
  renderCellStatus = node => {
    const { classes, t } = this.props;
    let status;

    switch (node.status) {
      case adStatus.PENDING_VERIFICATION:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.pending_verification')}
          </h6>
        );
        break;
      case adStatus.PENDING_PROCESSING:
        status = (
          <h6
            id={`ad-pending-processing-${node.id}`}
            className={`${classes.cellStatus} ${classes.pendingTag}`}
          >
            {t('ad.list.ad_status.pending_processing')}
          </h6>
        );
        break;
      case adStatus.PROCESSING:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.processing')}
          </h6>
        );
        break;
      case adStatus.TO_REVIEW:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.to_review')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_MODERATOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_moderator')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_PROCESSOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_processor')}
          </h6>
        );
        break;
      case adStatus.PUBLISHED_BY_PROCESSOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_processor')}
          </h6>
        );
        break;
      case adStatus.PUBLISHED_BY_MODERATOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_moderator')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER_DELETED:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_deleted')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER_BLOCKED:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_blocked')}
          </h6>
        );
        break;
      default:
        status = '';
        break;
    }
    return (
      <React.Fragment>
        <div className={classes.infoStatusAndReview}>{status}</div>
        {node.reviewed && (
          <div className={classes.reviewCheck}>
            <span>
              <Done />
              <WithPermission
                alt={<span>{node.reviewedBy && node.reviewedBy.fullname}</span>}
                allowPermissions={['view_user']}
              >
                <Button
                  data-cy="adReviewedByBtn"
                  id={`ads-reviewed-${node.id}`}
                  className={classes.adBtns}
                  simple
                  size="sm"
                  color="primary"
                  onClick={() => this.handleReadUser(node.reviewedBy.id)}
                >
                  {node.reviewedBy && node.reviewedBy.fullname}
                </Button>
              </WithPermission>
            </span>
            <span className={classes.dateFormat}>
              {dateFormat(node.reviewedOn, t)}
            </span>
          </div>
        )}
      </React.Fragment>
    );
  };

  /**
   * @description
   * To give a row color depending of column status.
   *
   * @param {number} nodeId - Id of an Ad.
   * @returns {string} Row color.
   */
  renderRowColor = nodeId => {
    const { data } = this.props;
    const node = data.ads.edges.find(({ node: { id } }) => id === nodeId);
    switch (node.node.status) {
      case adStatus.PENDING_VERIFICATION || adStatus.PROCESSING:
        return 'rgba(255, 181, 0, .1)';
      case adStatus.UNPUBLISHED_BY_USER:
        return 'rgba(81, 0, 14, .1)';
      case adStatus.UNPUBLISHED_BY_USER_DELETED:
        return 'rgba(81, 0, 14, .1)';
      case adStatus.UNPUBLISHED_BY_USER_BLOCKED:
        return 'rgba(81, 0, 14, .1)';
      default:
        if (node.node.reviewed) {
          return 'rgba(76, 175, 80, 0.15)';
        }
        return '';
    }
  };

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table columns.
   */
  renderColumns = edges => {
    const { selectedItems } = this.state;
    const { classes, appliedOrder, t } = this.props;
    return [
      {
        Header: (
          <Checkbox
            onClick={() => this.handleSelectAll(edges)}
            checked={edges && selectedItems.length === edges.length}
            id="allCheckbox"
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
            }}
          />
        ),
        accessor: 'checkbox',
        sortable: false,
        filterable: false,
        maxWidth: 58,
      },
      {
        Header: (
          <span
            className={
              appliedOrder.orderColumn === 'title'
                ? classes.sortField
                : classes.headerField
            }
          >
            {t('ad.list.headers.title')}
          </span>
        ),
        accessor: 'title',
        sortable: false,
        filterable: false,
        minWidth: 300,
      },
      {
        Header: (
          <span
            className={
              appliedOrder.orderColumn === 'user'
                ? classes.sortField
                : classes.headerField
            }
          >
            {t('ad.list.headers.user')}
          </span>
        ),
        accessor: 'user',
        sortable: false,
        filterable: false,
        maxWidth: 250,
        minWidth: 250,
      },
      {
        Header: (
          <div
            className={
              appliedOrder.orderColumn === 'ipScore'
                ? classes.sortField
                : classes.headerField
            }
          >
            {t('ad.list.headers.ipScore')}
          </div>
        ),
        accessor: 'ipScore',
        sortable: false,
        filterable: false,
        minWidth: 150,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.rules')}
          </span>
        ),
        accessor: 'rules',
        sortable: false,
        filterable: false,
        minWidth: 120,
      },
      {
        Header: (
          <div
            className={
              appliedOrder.orderColumn === 'public'
                ? classes.sortField
                : classes.headerField
            }
            style={{ textAlign: 'center' }}
          >
            {t('ad.list.headers.status')}
          </div>
        ),
        accessor: 'public',
        sortable: false,
        filterable: false,
        maxWidth: 500,
      },
      {
        Header: (
          <span className={classes.headerField} style={{ textAlign: 'center' }}>
            <p>{t('ad.list.headers.actions')}</p>
          </span>
        ),
        accessor: 'actions',
        sortable: false,
        filterable: false,
        maxWidth: 250,
      },
      {
        expander: true,
        show: false,
      },
    ];
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { selectedItems } = this.state;
    const { classes, t, filter, adsImages } = this.props;
    const history = this.context;

    const renderImages = node => (
      <div>
        {adsImages &&
          Object.keys(adsImages).length > 0 &&
          adsImages[node.id] && <ImageMosaic images={adsImages[node.id]} />}
      </div>
    );

    return edges.map(({ node }) => ({
      id: node.id,
      checkbox: (
        <Checkbox
          onClick={() => {
            this.handleSelectItem(node.id);
          }}
          checked={selectedItems.indexOf(node.id) !== -1}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
          }}
        />
      ),
      title: (
        <WithPermission
          alt={
            <div
              id={`ad-title-${node.id}`}
              data-cy="adTitle"
              className={classes.adTitleContainer}
            >
              {renderImages(node)}
              <div className={classes.idAndDate}>
                <WithPermission
                  allowPermissions={[
                    'view_autopaidad',
                    'view_ownership_autopaidad',
                  ]}
                >
                  {node.isAuto && <span className={classes.adAuto}>AUTO</span>}
                  {node.isPromoted && (
                    <span className={classes.adAuto}>DESTACADO</span>
                  )}
                </WithPermission>
                <p>
                  <b data-cy={node.id}>ID: {node.id}</b>
                  {node.flagCount > 0 && (
                    <span style={{ marginLeft: 8 }}>
                      <Badge color="danger">{node.flagCount}</Badge>
                    </span>
                  )}
                </p>
                <p className={classes.modificationDate}>
                  <Updated />
                  {node.updatedOn && dateFormat(node.updatedOn, t)}
                </p>
              </div>
              <p className={classes.adTitle}>{node.title}</p>
              <p
                className={classes.modificationDate}
                style={{ color: '#5f625f', fontWeight: 500 }}
              >
                <Map />
                {node.municipality && `${node.municipality.name}, `}
                {node.province.name}
              </p>
            </div>
          }
          allowPermissions={['view_ad']}
        >
          <div
            style={{ padding: '8px 0' }}
            id={`ad-title-${node.id}`}
            data-cy="adTitle"
          >
            {renderImages(node)}
            <div className={classes.idAndDate}>
              <WithPermission
                allowPermissions={[
                  'view_autopaidad',
                  'view_ownership_autopaidad',
                ]}
              >
                {node.isAuto && <span className={classes.adAuto}>AUTO</span>}
                {node.isPromoted && (
                  <span className={classes.adAuto}>DESTACADO</span>
                )}
              </WithPermission>
              <p style={{ marginRight: 8 }}>
                <b data-cy={node.id}>ID: {node.id}</b>
                {node.flagCount > 0 && (
                  <span style={{ marginLeft: 8 }}>
                    <Badge color="danger">{node.flagCount}</Badge>
                  </span>
                )}
              </p>
              <p className={classes.modificationDate}>
                <Updated /> {node.updateCount} •
                <span style={{ marginLeft: 4 }}>
                  {node.updatedOn && dateFormat(node.updatedOn, t)}
                </span>
              </p>
            </div>
            <ul
              key={`ad-subcategory-${node.id}`}
              className={classes.adCatBread}
            >
              <li data-cy="adCategory">
                {node.subcategory.parentCategory.title}
              </li>
              <li className={classes.adIconBread}>
                <ArrowForward color="disabled" />
              </li>
              <li data-cy="adSubcategory">{node.subcategory.title}</li>
            </ul>
            <a
              color="primary"
              className={['read', classes.adBtns, classes.titleBtn].join(' ')}
              href={formatRoute(AD.DETAILS, { id: node.id })}
              onClick={e => {
                e.preventDefault();
                history.push(formatRoute(AD.DETAILS, { id: node.id }));
              }}
            >
              {node.title}
            </a>
            <p
              className={classes.modificationDate}
              style={{ color: '#5f625f', fontWeight: 500 }}
            >
              <Map />
              {node.municipality && `${node.municipality.name}, `}
              {node.province.name}
            </p>
          </div>
        </WithPermission>
      ),
      ipScore: (
        <React.Fragment>
          <div className={[classes.botScore, classes.idAndDate].join(' ')}>
            <AddIco />
            <a
              color="primary"
              className={['read', classes.adBtns, classes.scoreLink].join(' ')}
              href={`${AD.LIST}?sameOwnerAds=${node.id}`}
              rel="noopener noreferrer"
              target="_blank"
              style={{ float: 'left' }}
            >
              {node.botScoreInsert !== null
                ? node.botScoreInsert
                : t('common.unknown')}
            </a>
            <span>{node.countryInsert || t('common.unknown')}</span>
            {node.ipInsert !== null ? (
              <Button
                simple
                color="primary"
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                onClick={() =>
                  filter({
                    ip: node.ipInsert,
                  })
                }
                style={{ marginLeft: '8px' }}
              >
                {node.ipInsert}
              </Button>
            ) : (
              <span style={{ marginLeft: '8px' }}>{t('common.unknown')}</span>
            )}
          </div>
          {node.updateCount > 0 && (
            <React.Fragment>
              <div className={[classes.botScore, classes.idAndDate].join(' ')}>
                <Edit />
                <a
                  color="primary"
                  className={['read', classes.adBtns, classes.scoreLink].join(
                    ' ',
                  )}
                  href={`${AD.LIST}?sameOwnerAds=${node.id}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ float: 'left' }}
                >
                  {node.botScoreUpdate !== null
                    ? node.botScoreUpdate
                    : t('common.unknown')}
                </a>
                <span>{node.countryUpdate || t('common.unknown')}</span>
                {node.ipUpdate !== null ? (
                  <Button
                    simple
                    color="primary"
                    className={['read', classes.adBtns, classes.titleBtn].join(
                      ' ',
                    )}
                    onClick={() =>
                      filter({
                        ip: node.ipUpdate,
                      })
                    }
                    style={{ marginLeft: '8px' }}
                  >
                    {node.ipUpdate}
                  </Button>
                ) : (
                  <span style={{ marginLeft: '8px' }}>
                    {t('common.unknown')}
                  </span>
                )}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      user: (
        <div data-cy="adUserInfo" className={classes.adUserContainer}>
          {node.user ? (
            node.user.id !== '0' ? (
              <>
                <WithPermission
                  alt={<span>{node.user.fullname}</span>}
                  allowPermissions={['view_user']}
                >
                  <Button
                    simple
                    color="primary"
                    className={['read', classes.adBtns, classes.titleBtn].join(
                      ' ',
                    )}
                    onClick={() =>
                      filter({
                        userId: node.user.id,
                      })
                    }
                    style={{ margin: 0 }}
                  >
                    ID: {node.user.id}
                  </Button>
                  <Button
                    simple
                    color="primary"
                    className={['read', classes.adBtns, classes.titleBtn].join(
                      ' ',
                    )}
                    onClick={() => this.handleReadUser(node.user.id)}
                  >
                    {node.user.fullname}
                  </Button>
                </WithPermission>
              </>
            ) : (
              <div id={`bundle-owner-${node.user.fakeId}`}>
                {`${t('promoted_ad.form.fields.private_user')} (${
                  node.user.fakeId
                })`}
              </div>
            )
          ) : (
            <p>
              <b>{node.name}</b>
            </p>
          )}
          <Button
            simple
            color="primary"
            className={['read', classes.adBtns, classes.titleBtn].join(' ')}
            onClick={() =>
              filter({
                emailTerm: node.email,
              })
            }
            style={{ margin: 0 }}
          >
            {node.email}
          </Button>
          <p data-cy="adUserPhone" key={`user-phone-${node.id}`}>
            {node.phone}
          </p>
        </div>
      ),
      rules:
        node.matchedRules &&
        Array.isArray(node.matchedRules) &&
        node.matchedRules.map((matchedRule, key) => {
          if (!isFromList(matchedRule)) {
            return matchedRules(node, classes, t, matchedRule);
          }
          return (
            <div
              key={`mr-list-${node.id}-${key}`}
              className={classes.matchedRule}
              dangerouslySetInnerHTML={{
                __html: matchedRules(node, classes, t, matchedRule),
              }}
            />
          );
        }),
      public: <div data-cy="status">{this.renderCellStatus(node)}</div>,
      actions: selectedItems.indexOf(node.id) === -1 && (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to unpublish the data row */}
          {(node.status === adStatus.PUBLISHED_BY_MODERATOR ||
            node.status === adStatus.PUBLISHED_BY_PROCESSOR ||
            node.status === adStatus.TO_REVIEW) && (
            <WithPermission allowPermissions={['publish_ad']}>
              <Tooltip
                placement="top"
                TransitionComponent={Zoom}
                title={
                  <React.Fragment>
                    {t('common.unpublish')}
                    <span className={classes.arrow} />
                  </React.Fragment>
                }
                classes={{
                  tooltip: classes.bootstrapTooltip,
                  tooltipPlacementTop: classes.bootstrapPlacementTop,
                }}
              >
                <Button
                  data-cy="adPublishOrUnpublishBtn"
                  justIcon
                  onClick={() => this.handleAction('unpublish', [node.id])}
                  className={`ad-published-${node.id}`}
                  color="danger"
                >
                  <UnPublish />
                </Button>
              </Tooltip>
            </WithPermission>
          )}
          {/* use this button to publish the data row */}
          {(node.status === adStatus.UNPUBLISHED_BY_MODERATOR ||
            node.status === adStatus.UNPUBLISHED_BY_PROCESSOR ||
            node.status === adStatus.TO_REVIEW) && (
            <WithPermission allowPermissions={['publish_ad']}>
              <Tooltip
                placement="top"
                TransitionComponent={Zoom}
                title={
                  <React.Fragment>
                    {t('common.publish')}
                    <span className={classes.arrow} />
                  </React.Fragment>
                }
                classes={{
                  tooltip: classes.bootstrapTooltip,
                  tooltipPlacementTop: classes.bootstrapPlacementTop,
                }}
              >
                <Button
                  data-cy="adPublishOrUnpublishBtn"
                  justIcon
                  onClick={() => this.handleAction('publish', [node.id])}
                  className={`ad-unpublished-${node.id}`}
                  color="success"
                  style={{ marginLeft: '4px' }}
                >
                  <Publish />
                </Button>
              </Tooltip>
            </WithPermission>
          )}
          {(node.status === adStatus.UNPUBLISHED_BY_MODERATOR ||
            node.status === adStatus.UNPUBLISHED_BY_PROCESSOR ||
            node.status === adStatus.TO_REVIEW) &&
            hasReviewCategoryRule(node) && (
              <WithPermission allowPermissions={['publish_ad']}>
                <Tooltip
                  placement="top"
                  TransitionComponent={Zoom}
                  title={
                    <React.Fragment>
                      {t('common.apply_rule_and_publish')}
                      <span className={classes.arrow} />
                    </React.Fragment>
                  }
                  classes={{
                    tooltip: classes.bootstrapTooltip,
                    tooltipPlacementTop: classes.bootstrapPlacementTop,
                  }}
                >
                  <Button
                    data-cy="adApplyRuleAndPublishBtn"
                    justIcon
                    onClick={() =>
                      this.handleAction(
                        'applyRuleAndPublish',
                        [node.id],
                        getReviewCategorySuggestion(node),
                      )
                    }
                    className={`ad-apply-rule-publish-${node.id}`}
                    color="info"
                    style={{ marginLeft: '4px' }}
                  >
                    <Publish />
                  </Button>
                </Tooltip>
              </WithPermission>
            )}
          {/* use this button to reprocess the data row */}
          <WithPermission allowPermissions={['review_ad']}>
            <Tooltip
              placement="top"
              TransitionComponent={Zoom}
              title={
                <React.Fragment>
                  {t('common.reprocess')}
                  <span className={classes.arrow} />
                </React.Fragment>
              }
              classes={{
                tooltip: classes.bootstrapTooltip,
                tooltipPlacementTop: classes.bootstrapPlacementTop,
              }}
            >
              <Button
                justIcon
                simple
                onClick={() => this.handleAction('reprocess', [node.id])}
                color="warning"
                data-cy="adReprocessBtn"
                className={`reprocess-ad-${node.id}`}
              >
                <Reprocess />
              </Button>
            </Tooltip>
          </WithPermission>
        </div>
      ),
    }));
  };

  /**
   * @description
   * Map Loading index Rows with itemProcessing.
   *
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @param {Object} edges - Edges of connection data.
   */
  mapLoadingRows = (itemProcessing, edges) => {
    const loadingRows = {};
    edges.forEach((value, index) => {
      if (itemProcessing.includes(value.node.id)) {
        loadingRows[index] = true;
      }
    });
    return loadingRows;
  };

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Filter, Paginator and ReactTable components.
   */
  render() {
    const {
      data,
      loading,
      fullLoading,
      appliedOrder,
      changeOrder,
      changeNumberOfRows,
      changePage,
      numberOfRowsSelected,
      paginationDirection,
      classes,
      filter,
      restartFilters,
      appliedFilter,
      itemProcessing,
      t,
      failedIds,
      showNotification,
      closeNotification,
    } = this.props;
    const {
      modalIsOpen,
      selectedItems,
      adTitle,
      showCollapseFilters,
    } = this.state;
    const edges = loading || data === undefined ? [] : data.ads.edges;
    const rows = this.renderRows(edges);
    const cols = this.renderColumns(edges);
    const loadingRows = this.mapLoadingRows(itemProcessing, edges);

    return (
      <React.Fragment>
        <Snackbar
          place="tc"
          color="danger"
          message={t(`common.failed_bulk_action`, {
            count: failedIds.length,
          })}
          open={showNotification}
          closeNotification={closeNotification}
          close
        />

        <ModalConfirmation
          show={modalIsOpen}
          confirm={() => this.handleSubmit()}
          cancel={() => this.handleCloseModal()}
          title={
            <span>
              {selectedItems.length > 0
                ? t('common.delete.ad_plural')
                : t('common.delete.ad')}
            </span>
          }
          description={adTitle}
          confirmLabel={`${t('common.delete.ad_confirm')} ${
            selectedItems.length > 0 ? 's' : ''
          }`}
        />
        <div className={classes.pageContainer}>
          <GridContainer justify="space-between" alignItems="center">
            <GridItem>
              <h3 className={classes.title}>{t('ad.list.title')}</h3>
            </GridItem>
            <GridItem>
              <Button
                color="primary"
                simple
                onClick={this.handleRefresh}
                id="refresh"
                key="refresh"
              >
                <Refresh />
                {t('ad.filters.update')}
              </Button>
            </GridItem>
          </GridContainer>

          <Filter
            filter={filter}
            appliedFilter={appliedFilter}
            restartFilters={restartFilters}
            showCollapseFilters={showCollapseFilters}
            showFilters={this.handleShowFilters}
          />

          <div className={classes.contentContainer}>
            <div
              className={[classes.loadingLineContainer, classes.topLine].join(
                ' ',
              )}
            >
              {' '}
              {fullLoading && (
                <LinearProgress
                  classes={{
                    barColorPrimary: classes.loadingLine,
                  }}
                />
              )}
            </div>
            <GridContainer>
              <GridItem
                className={[
                  classes.groupActions,
                  classes.loteActionsAnimation,
                  selectedItems.length > 0
                    ? classes.showLote
                    : classes.hideLote,
                ].join(' ')}
                xs={12}
              >
                <WithPermission allowPermissions={['publish_ad']}>
                  <Button
                    data-cy="publishLote"
                    color="success"
                    simple
                    onClick={() => this.handleAction('publish', selectedItems)}
                    id="publishAd"
                  >
                    <Publish />
                    {t('common.publish')}
                  </Button>
                  <Button
                    data-cy="unpublishLote"
                    color="danger"
                    simple
                    onClick={() =>
                      this.handleAction('unpublish', selectedItems)
                    }
                    id="unpublishAd"
                  >
                    <UnPublish />
                    {t('common.unpublish')}
                  </Button>
                </WithPermission>
                <WithPermission allowPermissions={['review_ad']}>
                  <Button
                    data-cy="reviewLote"
                    color="primary"
                    simple
                    onClick={() => this.handleAction('review', selectedItems)}
                    id="reviewAd"
                  >
                    <Done />
                    {t('common.review')}
                  </Button>
                  <Button
                    data-cy="unreviewLote"
                    color="primary"
                    simple
                    onClick={() => this.handleAction('unreview', selectedItems)}
                    id="unreviewAd"
                  >
                    <Done />
                    {t('common.unreview')}
                  </Button>
                  <Button
                    data-cy="reprocessLote"
                    color="warning"
                    simple
                    onClick={() =>
                      this.handleAction('reprocess', selectedItems)
                    }
                    id="reprocessAd"
                  >
                    <Reprocess />
                    {t('common.reprocess')}
                  </Button>
                </WithPermission>
              </GridItem>
              <GridItem
                className={[
                  classes.z2,
                  classes.loteActionsAnimation,
                  selectedItems.length > 0 ? classes.hideLote : '',
                ].join(' ')}
                xs={12}
              >
                <GridContainer justify="flex-end" alignItems="center">
                  <GridItem xs={12} sm={12} md={6} lg={8}>
                    <Order
                      appliedOrder={appliedOrder}
                      changeOrder={changeOrder}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={6} lg={4}>
                    {!fullLoading ? (
                      <Paginator
                        pageInfo={data.ads.pageInfo}
                        changePage={changePage}
                        queryCount={data.ads.meta.total}
                        changeNumberOfRows={changeNumberOfRows}
                        paginationDirection={paginationDirection}
                        numberOfRowsSelected={numberOfRowsSelected}
                      />
                    ) : (
                      <ContentLoader height={67} width={327} speed={2}>
                        <path
                          // eslint-disable-next-line max-len
                          d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                          fill="#D8D8D8"
                        />
                      </ContentLoader>
                    )}
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12} className={classes.z3}>
                <GridContainer>
                  <GridItem xs={12}>
                    {loading ? (
                      <TableLoader />
                    ) : (
                      <ReactTable
                        data={rows}
                        filterable
                        columns={cols}
                        loading={loading}
                        pageSize={
                          edges.length < numberOfRowsSelected
                            ? edges.length
                            : numberOfRowsSelected
                        }
                        showPagination={false}
                        className={['-striped -highlight', classes.tbl].join(
                          ' ',
                        )}
                        expanded={loadingRows}
                        defaultFilterMethod={(field, row) => {
                          const id = field.pivotId || field.id;
                          return row[id] !== undefined
                            ? String(row[id]).startsWith(field.value)
                            : true;
                        }}
                        SubComponent={() => (
                          <div className={classes.loading}>
                            <LoadingAnimation />
                          </div>
                        )}
                        getTrProps={(state, rowInfo) => ({
                          style: {
                            backgroundColor:
                              rowInfo &&
                              (selectedItems.indexOf(rowInfo.original.id) !== -1
                                ? 'rgba(171, 221, 250, .8)'
                                : this.renderRowColor(rowInfo.original.id)),
                            boxShadow:
                              rowInfo &&
                              failedIds.indexOf(rowInfo.original.id) !== -1
                                ? 'inset 4px 0 0 red'
                                : '',
                          },
                        })}
                        noDataText={t('common.no_data')}
                        minRows={8}
                      />
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer justify="flex-end" alignItems="center">
                  <GridItem xs={12} sm={8} md={6} lg={4}>
                    {!fullLoading ? (
                      <Paginator
                        pageInfo={data.ads.pageInfo}
                        queryCount={data.ads.meta.total}
                        changePage={changePage}
                        changeNumberOfRows={changeNumberOfRows}
                        paginationDirection={paginationDirection}
                        numberOfRowsSelected={numberOfRowsSelected}
                      />
                    ) : (
                      <ContentLoader height={67} width={327} speed={2}>
                        <path
                          // eslint-disable-next-line max-len
                          d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                          id="Combined-Shape"
                          fill="#D8D8D8"
                        />
                      </ContentLoader>
                    )}
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * AdList PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop ads query's results
 * @param itemProcessing - id of items that is processing
 * @param numberOfRowsSelected - prop current number of rows selected
 * @param appliedFilter - prop pass to Filter
 * @param appliedOrder - prop pass to Order
 * @param loading - prop ads query or mutations status
 * @param t - prop from HOC with string translations
 * @param failedIds - id of items that was failed after bulk action
 * @param showNotification - prop to know if notification will be showed or not
 * @callback adReview - callback to review elements
 * @callback adUnReview - callback to unReview elements
 * @callback adPublish - callback to publish elements
 * @callback adUnPublish - callback to unpublish elements
 * @callback adReprocess - callback to reprocess elements
 * @callback changePage - prop pass to Paginator
 * @callback changeNumberOfRows - prop pass to Paginator
 * @callback filter - prop pass to Filter
 * @callback restartFilters - prop pass to Filter
 * @callback changeOrder - prop pass to Order
 * @callback refresh - callback to refresh page
 * @callback closeNotification - callback to close notification
 */

AdList.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  itemProcessing: PropTypes.instanceOf(Array).isRequired,
  data: PropTypes.shape({}).isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  // eslint-disable-next-line react/require-default-props
  paginationDirection: PropTypes.string,
  adReview: PropTypes.func.isRequired,
  adUnReview: PropTypes.func.isRequired,
  adPublish: PropTypes.func.isRequired,
  adUnPublish: PropTypes.func.isRequired,
  adApplyRuleAndPublish: PropTypes.func.isRequired,
  adReprocess: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  changeNumberOfRows: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  appliedOrder: PropTypes.shape({}).isRequired,
  changeOrder: PropTypes.func.isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  failedIds: PropTypes.instanceOf(Array).isRequired,
  showNotification: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
  adsImages: PropTypes.instanceOf(Object).isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const AdWrapper = props => <AdList {...props} />;

export default withTranslation()(withStyles(extendedTablesStyle)(AdWrapper));
